/* MYOP Scent Finder — a lightweight scoring quiz.
   Each answer adds a point to a result key; the highest-scoring key
   reveals its matching result panel. No dependencies. */
(function () {
  if (customElements.get('scent-finder')) return;

  class ScentFinder extends HTMLElement {
    connectedCallback() {
      this.total = parseInt(this.dataset.total, 10) || 0;
      this.intro = this.querySelector('[data-finder-intro]');
      this.quiz = this.querySelector('[data-finder-quiz]');
      this.resultsWrap = this.querySelector('[data-finder-results]');
      this.bar = this.querySelector('[data-finder-bar]');
      this.backBtn = this.querySelector('[data-finder-back]');
      this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-step]'));
      this.results = Array.prototype.slice.call(this.querySelectorAll('[data-result-key]'));
      this.reset();

      var start = this.querySelector('[data-finder-start]');
      var restart = this.querySelector('[data-finder-restart]');
      if (start) start.addEventListener('click', this.begin.bind(this));
      if (restart) restart.addEventListener('click', this.begin.bind(this));
      if (this.backBtn) this.backBtn.addEventListener('click', this.back.bind(this));

      this.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-result]');
        if (opt && this.contains(opt)) this.answer(opt.dataset.result);
      }.bind(this));
    }

    reset() {
      this.current = 0;
      this.tally = {};
      this.history = [];
    }

    begin() {
      this.reset();
      if (this.intro) this.intro.hidden = true;
      if (this.resultsWrap) this.resultsWrap.hidden = true;
      this.results.forEach(function (r) { r.hidden = true; });
      if (this.quiz) this.quiz.hidden = false;
      this.showStep(0);
    }

    showStep(i) {
      this.current = i;
      this.steps.forEach(function (s, idx) { s.hidden = idx !== i; });
      if (this.backBtn) this.backBtn.hidden = i === 0;
      this.updateBar(i / this.total);
    }

    updateBar(frac) {
      if (this.bar) this.bar.style.width = Math.max(0, Math.min(1, frac)) * 100 + '%';
    }

    answer(key) {
      if (key) {
        this.tally[key] = (this.tally[key] || 0) + 1;
        this.history.push(key);
      } else {
        this.history.push(null);
      }
      if (this.current + 1 < this.steps.length) {
        this.showStep(this.current + 1);
      } else {
        this.finish();
      }
    }

    back() {
      if (this.current === 0) return;
      var last = this.history.pop();
      if (last && this.tally[last]) this.tally[last] -= 1;
      this.showStep(this.current - 1);
    }

    finish() {
      this.updateBar(1);
      // pick highest-scoring key (first result block wins ties)
      var winner = null, best = -1;
      var order = this.results.map(function (r) { return r.dataset.resultKey; });
      order.forEach(function (key) {
        var score = this.tally[key] || 0;
        if (score > best) { best = score; winner = key; }
      }.bind(this));

      var match = this.results.filter(function (r) { return r.dataset.resultKey === winner; })[0]
        || this.results[0];
      this.results.forEach(function (r) { r.hidden = r !== match; });
      if (this.quiz) this.quiz.hidden = true;
      if (this.resultsWrap) this.resultsWrap.hidden = false;
      this.resultsWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  customElements.define('scent-finder', ScentFinder);
})();
